import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, Fragment as _Fragment, renderList as _renderList } from "vue";
const _hoisted_1 = {
  class: "flex flex-col justify-center flex-1 min-w-0 mr-2"
};
const _hoisted_2 = ["title"];
const _hoisted_3 = {
  key: 0,
  class: "w-full mt-1"
};
const _hoisted_4 = {
  class: "text-xs text-[#86909C] mt-1"
};
const _hoisted_5 = {
  key: 1,
  class: "text-xs text-[#86909C] flex items-center"
};
const _hoisted_6 = ["title"];
const _hoisted_7 = {
  key: 0,
  class: "action-wrap justify-end items-center"
};
const _hoisted_8 = ["onClick"];
import { computed } from 'vue';
import { Refresh } from '@element-plus/icons-vue';
const __default__ = {
  name: 'UploadItem'
};
export default /*@__PURE__*/Object.assign(__default__, {
  props: {
    item: {
      type: Object,
      required: true
    },
    uploadState: {
      type: Object,
      default: () => null
    },
    showActions: {
      type: Boolean,
      default: true
    },
    customActions: {
      type: Array,
      default: () => []
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  emits: ['openWindow', 'replace', 'delete', 'cancel', 'retry'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const fileType = computed(() => {
      return props.item?.fileFormat?.toUpperCase() || '未知';
    });

    // 统一的文件状态计算
    const fileStatus = computed(() => {
      // 优先使用 uploadState 的状态，其次使用 item 的状态
      return props.uploadState?.status || props.item?.status || 'ready';
    });

    // 统一的进度计算
    const fileProgress = computed(() => {
      return props.uploadState?.progress ?? props.item?.progress ?? 0;
    });

    // 统一的错误信息计算
    const errorMessage = computed(() => {
      return props.uploadState?.error || props.item?.error || '';
    });

    // 状态检查计算属性
    const isUploading = computed(() => fileStatus.value === 'uploading');
    const isCompleted = computed(() => fileStatus.value === 'success');
    const hasError = computed(() => fileStatus.value === 'error');
    const isCancelled = computed(() => fileStatus.value === 'cancelled');
    const isReady = computed(() => fileStatus.value === 'ready');

    // 显示相关计算属性
    const showProgress = computed(() => isUploading.value);
    const progressValue = computed(() => Math.round(fileProgress.value));

    // 状态显示映射
    const statusConfig = computed(() => {
      const configs = {
        uploading: {
          text: '上传中',
          color: 'text-blue-500',
          icon: 'uploading'
        },
        error: {
          text: '上传失败',
          color: 'text-red-500',
          icon: 'error'
        },
        cancelled: {
          text: '已取消',
          color: 'text-gray-500',
          icon: 'cancelled'
        },
        ready: {
          text: '',
          color: '',
          icon: 'ready'
        },
        success: {
          text: '',
          color: '',
          icon: 'success'
        },
        // 成功不显示文字
        default: {
          text: '',
          color: 'text-gray-400',
          icon: 'default'
        }
      };
      return configs[fileStatus.value] || configs.default;
    });
    const displayStatus = computed(() => statusConfig.value.text);
    const statusColor = computed(() => statusConfig.value.color);
    const statusIcon = computed(() => statusConfig.value.icon);

    // 交互状态计算属性
    const canRetry = computed(() => hasError.value || isCancelled.value);
    // const canCancel = computed(() => isUploading.value)
    const canReplace = computed(() => !isUploading.value && props.editable);
    const canDelete = computed(() => !isUploading.value && props.editable);
    const isClickable = computed(() => !!props.item.url && isCompleted.value);

    // 样式类计算属性
    const fileItemClasses = computed(() => ({
      error: hasError.value,
      cancelled: isCancelled.value,
      uploading: isUploading.value,
      success: isCompleted.value,
      ready: isReady.value,
      clickable: isClickable.value
    }));
    const handleOpenWindow = () => {
      if (props.item.url) {
        emit('openWindow', props.item);
      }
    };
    const handleReplace = event => {
      event.stopPropagation();
      emit('replace', props.item);
    };
    const handleDelete = event => {
      event.stopPropagation();
      emit('delete', props.item);
    };
    const handleRetry = event => {
      event.stopPropagation();
      emit('retry', props.item);
    };
    const handleCustomAction = (action, event) => {
      event.stopPropagation();
      emit(action.event, props.item, action);
    };
    return (_ctx, _cache) => {
      const _component_i_home_doc = _resolveComponent("i-home-doc");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_i_home_delete = _resolveComponent("i-home-delete");
      const _component_i_home_replace = _resolveComponent("i-home-replace");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["file-item flex items-center w-[185px] h-[48px] bg-gray-100 rounded-md relative overflow-hidden", fileItemClasses.value]),
        onClick: handleOpenWindow
      }, [_createVNode(_component_i_home_doc, {
        class: "w-8 h-8 mr-[2px]"
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("p", {
        class: "text-xs text-[#4E5969] truncate",
        title: __props.item.fileName
      }, _toDisplayString(__props.item.fileName), 9, _hoisted_2), showProgress.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, "上传中..." + _toDisplayString(progressValue.value) + "%", 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("span", null, _toDisplayString(fileType.value), 1), displayStatus.value ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(["ml-2", statusColor.value])
      }, _toDisplayString(displayStatus.value), 3)) : _createCommentVNode("", true)])), hasError.value && errorMessage.value ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: "text-xs text-red-500 truncate mt-1",
        title: errorMessage.value
      }, _toDisplayString(errorMessage.value), 9, _hoisted_6)) : _createCommentVNode("", true)]), __props.showActions && __props.editable ? (_openBlock(), _createElementBlock("div", _hoisted_7, [canRetry.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_component_el_tooltip, {
        content: "重试",
        placement: "top"
      }, {
        default: _withCtx(() => [_createElementVNode("span", {
          class: "action-icon flex justify-center items-center mr-1",
          onClick: handleRetry
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_unref(Refresh))]),
          _: 1
        })])]),
        _: 1
      }), _createVNode(_component_el_tooltip, {
        content: "删除文件",
        placement: "top"
      }, {
        default: _withCtx(() => [canRetry.value ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "action-icon flex justify-center items-center",
          onClick: handleDelete
        }, [_createVNode(_component_i_home_delete, {
          class: "w-[14px] h-[14px]"
        })])) : _createCommentVNode("", true)]),
        _: 1
      })], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createVNode(_component_el_tooltip, {
        content: "替换文件",
        placement: "top"
      }, {
        default: _withCtx(() => [canReplace.value ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "action-icon flex justify-center items-center mr-1",
          onClick: handleReplace
        }, [_createVNode(_component_i_home_replace, {
          class: "w-[14px] h-[14px]"
        })])) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(_component_el_tooltip, {
        content: "删除文件",
        placement: "top"
      }, {
        default: _withCtx(() => [canDelete.value ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "action-icon flex justify-center items-center",
          onClick: handleDelete
        }, [_createVNode(_component_i_home_delete, {
          class: "w-[14px] h-[14px]"
        })])) : _createCommentVNode("", true)]),
        _: 1
      })], 64)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.customActions, action => {
        return _openBlock(), _createElementBlock("span", {
          key: action.key,
          class: "action-icon flex justify-center items-center",
          onClick: event => handleCustomAction(action, event)
        }, _toDisplayString(action.label), 9, _hoisted_8);
      }), 128))])) : _createCommentVNode("", true)], 2);
    };
  }
});